export const getCoreColor = (name) => {
  if (!name) return '#b6b6b6';
  const lowerName = name.toLowerCase();
  if (lowerName.includes('sio2')) return '#e2d587';
  if (lowerName.includes('tio2')) return '#949494';
  if (lowerName.includes('zno')) return '#f55353';
  if (lowerName.includes('ag')) return '#c0c0c0';
  return '#b6b6b6'; // domyślny szary
};
